import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './Home/home';
import AuthCallback from './AuthCallback/AuthCallback';
import Articleship from './Articleship/Articleship';
import DirectChat from './DirectChat/DirectChat';
import CallPage from './Call/CallPage';
import BhupendraPatelCallPage from './Call/BhupendraPatelCallPage';
import GujaratGovtCallPage from './Call/GujaratGovtCallPage';
import UserDashboard from './UserDashboard/UserDashboard';
import GovtDashboard from './GovtDashboard/GovtDashboard';
import { ErrorBoundary } from "react-error-boundary";
import notAvailableImage from "../src/images/not-available-img.svg";
import { retryFailedRequests } from "./utils/api";
import { useEffect, useState } from 'react';
import ReactPixel from 'react-facebook-pixel';

const handleVisibilityChange = () => {
  if (!document.hidden) {
    console.log('Tab is now active, retrying failed requests...');
    retryFailedRequests();
  } else {
    console.log('Tab is now hidden');
  }
};

// Page focus handler (additional Safari support)
const handlePageFocus = () => {
  console.log('Page focused, retrying failed requests...');
  retryFailedRequests();
};

// Initialize tab visibility detection
export const initializeTabVisibilityDetection = () => {
  // Primary method - visibility API
  document.addEventListener('visibilitychange', handleVisibilityChange);

  // Fallback methods for better Safari support
  window.addEventListener('focus', handlePageFocus);
  window.addEventListener('pageshow', handlePageFocus);

  // Cleanup function
  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('focus', handlePageFocus);
    window.removeEventListener('pageshow', handlePageFocus);
  };
};

function ErrorFallback({ error, resetErrorBoundary }) {
  useEffect(() => {
    // Alert the error message
    if (error) {
      alert(`Error: ${error.message || error.toString()}`);
    }

    // Auto-refresh every 10 seconds
    const refreshInterval = setInterval(() => {
      window.location.reload();
    }, 10000);

    ReactPixel.init('1216201373713523');

    // Cleanup interval on component unmount
    return () => {
      clearInterval(refreshInterval);
    };
  }, [error]);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center', 
      alignItems: 'center', 
      height: "100vh",
      height: "100dvh",
      gap: '20px',
      backgroundColor: '#0a0a12'
    }}>
      <div style={{
        color: '#ffffff',
        fontSize: '22px',
        fontWeight: 600,
        textAlign: 'center',
        padding: '0 20px'
      }}>
        CA Circle is under maintenance
      </div>
      <button 
        onClick={handleRetry}
        style={{
          padding: '12px 24px',
          backgroundColor: '#007AFF',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '500',
          cursor: 'pointer',
          fontFamily: 'SF Pro, sans-serif',
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = '#0056CC';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = '#007AFF';
        }}
      >
        Retry
      </button>
    </div>
  );
}

function App() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    localStorage.setItem('darkMode', darkMode);
    console.log('Dark mode:', darkMode); // Debug log
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => !prev);
  };

  useEffect(() => {
    // Initialize Facebook Pixel
    ReactPixel.init('1216201373713523');
    
    // Initialize tab visibility detection when app mounts
    const cleanupVisibilityDetection = initializeTabVisibilityDetection();
    // Cleanup when component unmounts
    return () => {
      cleanupVisibilityDetection();
    };
  }, []);

  return (
    <div className="App">
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
      >
        <Router>
          <Routes>
            <Route path='/' element={<Home darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/auth/callback" element={<AuthCallback darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/articleship" element={<Articleship />} />
            <Route path="/nishantkumar" element={<DirectChat slug="nishantkumar" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/scannerexpert" element={<DirectChat slug="scannerexpert" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/neerajarora" element={<DirectChat slug="neerajarora" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/aakashkandoi" element={<DirectChat slug="aakashkandoi" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/vanshgoyal" element={<DirectChat slug="vanshgoyal" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/kushallodha" element={<DirectChat slug="kushallodha" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/umeshsharma" element={<DirectChat slug="umeshsharma" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/jksc-audit-expert" element={<DirectChat slug="jksc-audit-expert" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/paraggupta" element={<DirectChat slug="paraggupta" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/gujaratgovt" element={<DirectChat slug="gujaratgovt" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/chinmaya" element={<DirectChat slug="chinmaya" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/call" element={<CallPage />} />
            <Route path="/call/bhupendrapatel" element={<BhupendraPatelCallPage />} />
            <Route path="/call/gujaratgovt" element={<GujaratGovtCallPage />} />
            <Route path="/userdashboard" element={<UserDashboard />} />
            <Route path="/govtdashboard" element={<GovtDashboard />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </div>
  );
}

export default App;